export default "__VITE_ASSET__CS35Z6nq__"